var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#121B5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9399 14C15.9397 14.5305 15.7287 15.0391 15.3534 15.4139C14.9782 15.7888 14.4694 15.9993 13.9389 15.999C13.4085 15.9988 12.8999 15.7878 12.525 15.4125C12.1501 15.0373 11.9397 14.5285 11.9399 13.998C11.9402 13.4676 12.1512 12.959 12.5264 12.5841C12.9017 12.2092 13.4105 11.9988 13.9409 11.999C14.4714 11.9993 14.98 12.2103 15.3549 12.5855C15.7297 12.9608 15.9402 13.4696 15.9399 14ZM15.9999 17.48H11.9999V30H15.9999V17.48ZM22.3199 17.48H18.3399V30H22.2799V23.43C22.2799 19.77 27.0499 19.43 27.0499 23.43V30H30.9999V22.07C30.9999 15.9 23.9399 16.13 22.2799 19.16L22.3199 17.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinIcon1);
export default __webpack_public_path__ + "static/media/lin-icon-1.9ca6ca987ad04cd51ac2046784dedd2f.svg";
export { ForwardRef as ReactComponent };